module.exports = __webpack_public_path__ + "img/mobile-43.83e8f523.png";